/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Admin_View_OrgsInputs */



/**
* | output |
* | --- |
* | "View {count} organizations" |
*
* @param {Partner_Admin_View_OrgsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_view_orgs = /** @type {((inputs: Partner_Admin_View_OrgsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_View_OrgsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Organisationen anzeigen`)
	return /** @type {LocalizedString} */ (`View ${i?.count} organizations`)
});